import { DateTime } from 'luxon'
import { generateContext } from 'parkdepot-shared/utils/contextGenerator'

// types
import { Checkout } from '../../types/checkout.interface'
import { Lot } from '../../types/lot.interface'
import { Vehicle } from '../../types/vehicle.interface'

export interface ICheckoutContext {
    checkout: Checkout | null
    selectedVehicles: Vehicle[]
    email: string
    modifyAndSetCheckout: (checkout: Checkout) => void
    modifyAndSetHourlyCheckout: (lot: Lot, price: number, duration: number) => void
    modifyAndSetDailyCheckout: (lot: Lot, price: number, start_datetime: DateTime, end_datetime: DateTime) => void
    modifyAndSetNightlyCheckout: (lot: Lot, price: number, start_datetime: DateTime, end_datetime: DateTime) => void
    modifyAndSetSubscriptionCheckout: (lot: Lot, price: number, start_datetime: DateTime) => void
    setCheckout: (checkout: Checkout) => void
    setSelectedVehicles: React.Dispatch<React.SetStateAction<Vehicle[]>>
    setEmail: (email: string) => void
}

const [CheckoutContext, CheckoutContextProvider] = generateContext<ICheckoutContext>()

export { CheckoutContext }
export default CheckoutContextProvider
